<template>
  <div class="app-activation-tariff-options-view">
    <div class="options">
      <div class="option" v-for="tariffOption in tariff.allTariffOptions" :key="tariffOption.tariffoptionId">
        <dyn-slot :slot-data="formatTariffOption(tariffOption)">
          <slot :name="`txtTariffOptionDetails${tariffOption.tariffoptionId}`"></slot>
        </dyn-slot>
      </div>
    </div>
  </div>
</template>

<script>

import slotProxy from '@/mixins/slotProxy'
import durationUnit from '@/mixins/durationUnit'
import price from '@/mixins/price'

export default {
  name: 'TariffOptionsOverview',
  mixins: [
    slotProxy(),
    durationUnit,
    price
  ],
  computed: {
  },
  props: {
    tariff: {
      type: Object,
      default: null
    }
  },
  methods: {
    formatTariffOption (tariffOption) {
      return {
        price: this.price(tariffOption.price),
        name: tariffOption.name,
        unit: this.durationUnit(tariffOption.duration.unit, tariffOption.duration.amount),
        amount: tariffOption.duration.amount
      }
    }
  }
}
</script>
